// extracted by mini-css-extract-plugin
export default {"myLink":"MyLink_myLink__pQsk3"};